<template>
  <v-row dense>
    <v-col cols="12">
      <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'" elevation="0"
        class="all-trade-tab rounded-0">
        <v-tabs :background-color="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-2'
          " v-model="model">
          <v-tab class="ml-0" v-if="hasTrxHisAccess" :href="`#tab-1`">Trx. History</v-tab>
          <v-tab v-if="hasDepositAccess" :href="`#tab-2`"> Deposit </v-tab>
          <v-tab v-if="hasWithdrawAccess" :href="`#tab-3`"> Withdraw </v-tab>
          <v-tab v-if="hasIntxInAccess" :href="`#tab-4`"> Internal Transfer </v-tab>
          <v-tab v-if="hasCreditInAccess" :href="`#tab-5`"> Credit in </v-tab>
          <v-tab v-if="hasCreditOutAccess" :href="`#tab-6`"> Credit Out </v-tab>
          <v-tabs-items v-model="model">
            <v-tab-item :value="`tab-1`">
              <v-card flat>
                <TrxSummeryTab></TrxSummeryTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-2`">
              <v-card flat>
                <DepositTab></DepositTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-3`">
              <v-card flat>
                <WithdrawTab></WithdrawTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-4`">
              <v-card flat>
                <TransferTab></TransferTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-5`">
              <v-card flat>
                <CreditInTab></CreditInTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-6`">
              <v-card flat>
                <CreditOutTab></CreditOutTab>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CreditInTab from "@/components/Transactions/CreditInTab.vue";
import CreditOutTab from "@/components/Transactions/CreditOutTab.vue";
import DepositTab from "@/components/Transactions/DepositTab.vue";
import TransferTab from "@/components/Transactions/TransferTab.vue";
import TrxSummeryTab from "@/components/Transactions/TrxSummeryTab.vue";
import WithdrawTab from "@/components/Transactions/WithdrawTab.vue";
export default {
  data() {
    return {
      tab: null,
      model: "tab-4",
    };
  },
  components: {
    TrxSummeryTab,
    DepositTab,
    WithdrawTab,
    TransferTab,
    CreditInTab,
    CreditOutTab,
  },

  computed: {
    hasTrxHisAccess() {
      return this.$canRoute('transaction-history') > 0;
    },
    hasCreditInAccess() {
      return this.$canRoute('credit-in') > 0;
    },
    hasCreditOutAccess() {
      return this.$canRoute('credit-out') > 0;
    },
    hasDepositAccess() {
      return this.$canRoute('deposit') > 0;
    },
    hasIntxInAccess() {
      return this.$canRoute('internal-transctions') > 0;
    },
    hasWithdrawAccess() {
      return this.$canRoute('withdraw') > 0;
    }
  },
}

</script>

<style></style>
